import URLSearchParams from 'url-search-params';
import pick from 'lodash.pick';

export const appendTripParams = (detailPageUrl, inputParams) => {
    if (!detailPageUrl) {
        return null;
    }
    if (!inputParams) {
        inputParams = {};
    }

    if (detailPageUrl.indexOf('?') === -1) {
        detailPageUrl += '?';
    }

    const urlParts = detailPageUrl.split('?');
    const searchParams = new URLSearchParams(urlParts[1]);
    inputParams.noDates = !(inputParams.arrival && inputParams.departure);
    if (inputParams.noDates) {
        // all dates or no dates
        inputParams.arrival = null;
        inputParams.departure = null;
    }
    const supportedParams = [
        'arrival',
        'departure',
        'noDates',
        'adultsCount',
        'childrenCount',
        'petIncluded'
    ];
    const detailsPageTripParams = pick(inputParams, supportedParams);

    supportedParams.forEach((key) => {
        if (searchParams.has(key)) {
            searchParams.delete(key);
        }
        if (
            detailsPageTripParams.hasOwnProperty(key) &&
            detailsPageTripParams[key] !== null &&
            detailsPageTripParams[key] !== false && // skip defaults noDates=false and petIncluded=false
            detailsPageTripParams[key] !== 0 // skip defaults childrenCount=0
        ) {
            searchParams.append(key, detailsPageTripParams[key]);
        }
    });

    return `${urlParts[0]}?${searchParams.toString()}`;
};

export const appendTripParamsToDetailPageUrl = (listings, inputParams) => {
    return listings.map((listing) => ({
        ...listing,
        detailPageUrl: appendTripParams(listing.detailPageUrl, inputParams)
    }));
};
